import React from "react"
import PropTypes from "prop-types"

const Geolocalize = ({ fillColor }) => (
  <svg
    width="19"
    height="24"
    viewBox="0 0 19 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.323486 8.58716C0.323486 2.20183 5.32883 0 9.61913 0C13.9094 0 18.6764 3.08257 18.6764 8.58716C18.6764 12.9908 12.6382 20.6972 9.61913 24C6.52058 20.6239 0.323486 12.8147 0.323486 8.58716ZM9.01414 4.27345C8.61652 4.39617 8.18315 4.83989 8.07298 5.23707C8.04655 5.33222 8.02558 5.92428 8.02544 6.57771L8.02517 7.74794H6.82904H5.63287L5.35064 7.88916C4.86108 8.1341 4.59917 8.52845 4.56357 9.07441C4.53511 9.51071 4.63301 9.8038 4.91047 10.1128C5.02684 10.2424 5.22848 10.4046 5.35851 10.4733L5.59496 10.5982L6.81006 10.6132L8.02517 10.6282V11.7983C8.02517 13.1487 8.04725 13.2621 8.38317 13.6362C8.69734 13.986 8.97961 14.115 9.437 14.1176C9.7202 14.1192 9.85764 14.0965 10.0213 14.021C10.3281 13.8796 10.595 13.6193 10.7433 13.3169L10.872 13.0545L10.8863 11.8407L10.9007 10.6269L12.1362 10.6125L13.3716 10.5982L13.6337 10.4694C13.9357 10.3209 14.1957 10.0536 14.337 9.74647C14.487 9.42038 14.4733 8.8722 14.3072 8.55033C14.163 8.27105 13.9124 8.01207 13.6494 7.87067C13.4749 7.77686 13.3906 7.77028 12.183 7.75689L10.9018 7.74261L10.8869 6.50555L10.872 5.26844L10.7447 5.02666C10.5898 4.7325 10.3566 4.49197 10.0954 4.35701C9.87467 4.24295 9.2655 4.19591 9.01414 4.27345Z"
      fill={fillColor}
    />
  </svg>
)

Geolocalize.propsTypes = {
  fillColor: PropTypes.string,
}

Geolocalize.defaultProps = {
  fillColor: "white",
}

export { Geolocalize }
